var riot = require('riot');
riot.tag('app-footer', '<p><a href="https://github.com/cognitom/riot-checker">GitHub</a></p>', 'app-footer , [riot-tag="app-footer"] { border-top: 1px solid #eee; display: block; padding: 1em; text-align: center; } app-footer a , [riot-tag="app-footer"] a { color: #aaa; } app-footer p , [riot-tag="app-footer"] p { margin: 0; font-size: 90%; }', function(opts) {


});
